"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIONS = void 0;
var ACTIONS;
(function (ACTIONS) {
    ACTIONS["Read"] = "r";
    ACTIONS["Write"] = "r,c,u,d";
    ACTIONS["Create"] = "r,c";
    ACTIONS["Update"] = "r,u";
    ACTIONS["Delete"] = "r,d";
})(ACTIONS = exports.ACTIONS || (exports.ACTIONS = {}));
//# sourceMappingURL=types.js.map